import { ActiveVote } from "@/appInterface/windows/ActiveVote";
import { BottomBar } from "@/appInterface/windows/bottomBar";
import { CommentsWindow } from "@/appInterface/windows/CommentsWindow/CommentsWindow";
import { CursorTrackingWindow } from "@/appInterface/windows/cursorTrackingWindow/cursorTrackingWindow";
import { ExportWindow, ImageExportWindow } from "@/appInterface/windows/ExportWindow";
import { EditTextWindow } from "@/appInterface/windows/editTextWindow/editTextWindow";
import { NavigationSelectWindow } from "@/appInterface/windows/navigationSelectWindow";
import { PasswordWindow } from "@/appInterface/windows/passwordWindow";
import { ReconnectWindow } from "@/appInterface/windows/reconnectWindow";
import { SettingsWindow } from "@/appInterface/windows/settingsWindow";
import { ShortcutsWindow } from "@/appInterface/windows/shortcutsWindow";
import { StickersWindow } from "@/appInterface/windows/stickersWindow/stickersWindow";
import { UsersWindow } from "@/appInterface/windows/usersWindow/usersWindow";
import { VoteWindow } from "@/appInterface/windows/VoteWindow";
import { LinkPopupController } from "@/elements/text/linkPopup";
import { LinkInputController } from "@/interface/LinkInput";
import { UpdateTariffWindow } from "./windows/UpdateTariff";

export class appInterface {
    usersWindow: UsersWindow;
    settingsWindow: SettingsWindow;
    shortcutsWindow: ShortcutsWindow;
    reconnectWindow: ReconnectWindow;
    passwordWindow: PasswordWindow;
    navigationSelectWindow: NavigationSelectWindow;
    stickersWindow: StickersWindow;
    bottomBar: BottomBar;
    editTextWindow: EditTextWindow;
    cursorTrackingWindow: CursorTrackingWindow;
    exportWindow: ExportWindow;
    imageExportWindow: ImageExportWindow;
    commentsWindow: CommentsWindow;
    updateTariffWindow: UpdateTariffWindow;
    voteWindow: VoteWindow;
    activeVote: ActiveVote;
    linkInputController: LinkInputController;
    linkPopupController: LinkPopupController;

    constructor() {
        this.usersWindow = new UsersWindow();
        this.settingsWindow = new SettingsWindow();
        this.shortcutsWindow = new ShortcutsWindow();
        this.reconnectWindow = new ReconnectWindow();
        this.passwordWindow = new PasswordWindow();
        this.navigationSelectWindow = new NavigationSelectWindow();
        this.stickersWindow = new StickersWindow();
        this.bottomBar = new BottomBar();
        this.editTextWindow = new EditTextWindow();
        this.cursorTrackingWindow = new CursorTrackingWindow();
        this.exportWindow = new ExportWindow();
        this.imageExportWindow = new ImageExportWindow();
        this.commentsWindow = new CommentsWindow();
        this.updateTariffWindow = new UpdateTariffWindow();
        this.voteWindow = new VoteWindow();
        this.activeVote = new ActiveVote();
        this.linkInputController = new LinkInputController();
        this.linkPopupController = new LinkPopupController();
    }

    show() {
        this.bottomBar.show();
    }

    createTooltipContent(defaultLabel = "") {
        return (reference) => {
            const label = reference.getAttribute("toolTipName") || defaultLabel;
            const hotkey = reference.getAttribute("data-hotkey") || "";

            const container = document.createElement("div");
            container.classList.add("barPanelTooltip-content");

            const labelEl = document.createElement("span");
            labelEl.classList.add("barPanelTooltip-label");
            labelEl.textContent = label;
            container.appendChild(labelEl);

            if (hotkey) {
                const hotkeyEl = document.createElement("span");
                hotkeyEl.classList.add("barPanelTooltip-hotkey");
                hotkeyEl.textContent = hotkey;
                container.appendChild(hotkeyEl);
            }

            return container;
        };
    }

    inputFocused = 0;
}
